/**
 * Parser za datume iz mešanih virov (naša baza, Lisjak, CSV/Excel):
 *  - ISO 8601: "1984-01-29", "1984-01-29T00:00:00Z"
 *  - Slovenski: "29. 01. 1984", "29.01.1984", "29/01/1984"
 *  - JS Date objekt
 * Vrne Date objekt ali null, če ne moremo parsirati.
 */
export function parseSloDate(v) {
  if (!v) return null;
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  const s = String(v).trim();
  if (!s) return null;

  // 1) ISO – JS Date to zna
  const asIso = new Date(s);
  if (!isNaN(asIso.getTime()) && /^\d{4}-\d{2}-\d{2}/.test(s)) return asIso;

  // 2) Slovenski formati: dd. mm. yyyy, dd.mm.yyyy, dd/mm/yyyy
  const m = s.match(/^(\d{1,2})[.\-/]\s*(\d{1,2})[.\-/]\s*(\d{4})/);
  if (m) {
    const d = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    const y = parseInt(m[3], 10);
    const dt = new Date(y, mo, d);
    if (!isNaN(dt.getTime())) return dt;
  }

  // 3) Zadnji poskus: naravno – morda ISO brez ločila
  if (!isNaN(asIso.getTime())) return asIso;
  return null;
}

/** Vrni datum kot "d. m. yyyy" (sl-SI) ali "" če neveljaven. */
export function formatSloDate(v) {
  const d = parseSloDate(v);
  if (!d) return "";
  return d.toLocaleDateString("sl-SI");
}

/** Vrni število let od podanega datuma do danes; null če ni veljaven. */
export function yearsSince(v) {
  const d = parseSloDate(v);
  if (!d) return null;
  return Math.floor((Date.now() - d.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
}
